export default __webpack_public_path__ + "static/media/mobile1.5f1bb4a8.jfif";